import { directoryForOrgKind, type OrgKind } from '@app/shared'
import type { SiteLink } from '../../ui/SiteShell'

const directoryLink = (kind: OrgKind): SiteLink => {
  const directory = directoryForOrgKind(kind)
  if (!directory) throw new Error(`No public directory for ${kind}`)
  return {
    label: directory.navLabel,
    href: `/${directory.path}`,
  }
}

/**
 * The masthead nav for the institutional product's site, written once because
 * both of its pages carry it.
 *
 * The anchor is absolute rather than a bare fragment so the nav works from the
 * directory too — a `#features` link from `/shuls` would scroll that page to
 * nothing.
 */
export const PRODUCT_NAV: SiteLink[] = [
  { label: 'Features', href: '/#features' },
  directoryLink('shul'),
]

/** The giving product carries the same way to its directory on every page. */
export const TERUMAH_NAV: SiteLink[] = [directoryLink('chesed')]
